import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Modal as bsModal } from "bootstrap";

import { connectForm, Form } from "../utils/components/form";
import { console } from "../utils/functions";
import { InputField } from "../Mitarbeiter/components";
import { ModalLayout } from "./ModalLayout";
import { KontoDeckungPopup } from "./kontoDeckungPopup";
import { RESPONSE_HEADER } from "../utils/enums";

class VerifyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      tlsCode: null,
      passwort: null,
      tlsCodeHasBeenSent: false,
      tlsCodeSendFailed: false,
    };
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.sendeTLSCode = this.sendeTLSCode.bind(this);
    this.validPassword = this.validPassword.bind(this);
    this.handleSubmit = (args) => {
      console.log("handleSubmit", args);
    };
  }

  onSubmit = formValues => {
    this.props.onSubmit(formValues);
    const modal = document.querySelector("#flipFlopp");
    if (modal) {
      bsModal.getOrCreateInstance(modal).hide();
    }
  };

  async sendeTLSCode(e) {
    e.preventDefault();
    // tlsCode should only be send the first time
    if (!this.props.tlsCodeVerifyFailed) {
      let sendeTlsCodeRequestData = this.props.configStorage.getRequestData("sendeTlsCode", "get", {
        warenkorbId: this.props.basketStorage.warenkorbId
      });
      let header = this.props.configStorage.getRequestHeader();
      let config = {
        headers: {
          request: JSON.stringify(header)
        }
      };
      let axiosVerify = axios.create(config);
      // check for errors
      this.setState({ tlsCodeHasBeenSent: true });
      await axiosVerify[sendeTlsCodeRequestData.request.type](sendeTlsCodeRequestData.url, { header })
        .then(sendeTlsCodeResult => {
          if (
            sendeTlsCodeResult &&
            sendeTlsCodeResult.data &&
            sendeTlsCodeResult.data.header &&
            sendeTlsCodeResult.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL
            && !sendeTlsCodeResult.data.error
          ) {
            this.setState({ tlsCodeSendFailed: false });
          } else {
            this.setState({ tlsCodeSendFailed: true });
          }
        })
        .catch(e => {
          console.error(e);
          this.setState({ tlsCodeSendFailed: true });
        });
    }
  }

  validPassword(value) {
    if (!value) {
      return "Bitte geben Sie Ihr Passwort ein.";
    }
  }

  renderFormular() {
    if (!this.props.filled) return;
    if (this.state.tlsCodeHasBeenSent && this.state.tlsCodeSendFailed) {
      return (
        <ModalLayout>
          <div className="modal-body fs-5">
            <div id="modaltext">
              Bei der Übersendung der TLSCodes ist ein Fehler aufgetreten
            </div>
            <br />
          </div>
        </ModalLayout>
      );
    }

    if (this.props.kontoDeckungVerifyFailed) {
      return (
        <KontoDeckungPopup
          akzeptiereNichtGedecktesKonto={this.props.akzeptiereNichtGedecktesKonto}
          isMAShop={this.props.configStorage.isMaShop()}
        >
        </KontoDeckungPopup>
      );
    }

    let modalText = ` Aus Sicherheitsgründen erhalten Sie einen 8-stelligen Code sowie die vorvertraglichen Informationen.
      Bitte überprüfen Sie jetzt Ihr angegebenes E-Mail-Postfach.
      Geben Sie anschließend hier den Code ein, um Ihre Bestellung abzuschließen.`;
    if (this.props.tlsCodeVerifyFailed) {
      let passwordText = "";
      if (this.props.configStorage.isMaShop()) {
        passwordText = " oder das Beraterpasswort";
      }
      modalText = `Der TLS-Code${passwordText} war nicht korrekt.
          Bitte überprüfen Sie ihren Code und geben ihn erneut ein.`;
    }

    return (
      <ModalLayout title="Sicherheitsverifizierung">
        <div className="modal-body fs-5">
          <div id="modaltext">
            {modalText}
          </div>
          <br />

          <InputField name="tlsCode"
            label="8-stelliger TLSCode eingeben: "
            type="text"
            placeholder={"TLSCode"}
            maxLength="8"
            labelClass="col-12 col-md-5 col-lg-8 float-start fs-4 text-gray"
            inputClass="col-12 col-md-7 col-lg-4 float-end"
            disabled={this.props.showVerifyErrorMsg}
            required
          />
          {this.props.configStorage.isMaShop() ?
            (<InputField name="passwort"
              label="Passwort eingeben: "
              type="password"
              placeholder={"Passwort"}
              labelClass="col-12 col-md-5 col-lg-8 float-start fs-4 text-gray"
              inputClass="col-12 col-md-7 col-lg-4 float-end"
              disabled={this.props.showVerifyErrorMsg}
              required
              validate={this.validPassword}
            />)
            : null}

        </div>
        <div className="modal-footer justify-content-between">
          <button type="button"
            data-bs-dismiss="modal"
            className="btn btn-danger"
          >
            Abbrechen
          </button>
          {!this.props.showVerifyErrorMsg
            ? <button type="submit"
              className="btn btn-success float-end"
            >
              Kostenpflichtig bestellen
            </button>
            : <div className="ui error message text-danger w-100">
              <div className="header">Eine weitere Eingabe des Codes wurde verweigert. Bitte wechseln sie zurück in den Shop und
                erstellen sie einen neuen Warenkorb.</div>
            </div>
          }
        </div>
      </ModalLayout >
    );
  }

  onClick(e) {
    if (this.props.filled) {
      this.setState({ show: true });
      const modal = document.querySelector("#flipFlopp");
      if (modal) {
        bsModal.getOrCreateInstance(modal).show();
        modal.addEventListener("hide.bs.modal", () => this.setState({ show: false }));
      }
      this.sendeTLSCode(e);
    } else if (typeof this.props.checkFormular === "function") {
      this.props.checkFormular(this.props.beraterFeld);
    }
  }

  render() {
    return (
      <Form onSubmit={this.onSubmit} {...this.props}>
        {props => {
          this.handleSubmit = props.handleSubmit;
          return (
            <div className="float-end col-12 col-md-4 col-lg-3">
              <button type="button"
                // id="admin-btn" 
                id="modalbutton"
                className="btn btn-success col-12"
                data-backdrop="static"
                disabled={this.state.show || !this.props.filled || this.props.showVerifyErrorMsg}
                onClick={this.onClick}
              >
                Bestellung verifizieren
              </button>
              <div className="btn-popup">
                <form onSubmit={this.handleSubmit} className="form-group">
                  {this.renderFormular()}
                </form>
              </div>
            </div>
          );
        }}
      </Form>
    );
  }
}

const validate = (formValues, ...rest) => {
  const errors = {};
  if (!formValues.tlsCode) {
    errors.tlsCode = "Bitte überprüfen Sie Ihre Eingabe.";
  } else if (formValues.tlsCode.length !== 8) {
    errors.tlsCode = "TlsCode muss 8-stellig sein.";
  }
  return errors;
};

export default connectForm({
  form: "verifyForm",
  validate: validate
})(connect((store) => {
  return {
    configStorage: store.configStorage,
    basketStorage: store.basketStorage,
  };
})(VerifyForm));
